import { connect } from 'react-redux';

import Callout from '../shared/components/Callout';
import { hideCallout } from '../actionCreators/uiActions';

export default connect(
  ({ ui }) => ({
    showCallout: ui && ui.showCallout
  }),
  dispatch => ({
    hideCallout: () => dispatch(hideCallout())
  })
)(Callout);
